import { useEffect, useRef } from 'react';

import { useLanguage } from '../utils/LanguageContext';

export const useMELTranslations = (modelData) => {
    const { currentLanguage, translateContent, loading: isTranslating, error } = useLanguage();
    const previousModelRef = useRef(null);
    const previousLanguageRef = useRef(currentLanguage);

    useEffect(() => {

        // Only translate if modelData or language has changed
        if (modelData &&
            (JSON.stringify(modelData) !== JSON.stringify(previousModelRef.current) ||
                currentLanguage !== previousLanguageRef.current)) {
            translateContent(modelData);
            previousModelRef.current = modelData;
            previousLanguageRef.current = currentLanguage;
        }
    }, [modelData, currentLanguage, translateContent]);

    return { isTranslating, error };
};